import { AppStoreButtons } from '../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Heading } from '../../Heading/Heading';
import NextImage from 'next/image';

import logo from './assets/logo.png';
import AppsBannerBackground from './assets/AppsBannerBackground.png';
import { QRCode } from '../../QRCode/QRCode';
import { twMerge } from 'tailwind-merge';

export interface IDownloadHorizontalCTAProps {
  className?: string;
  bodyText?: string;
}

export const DownloadAppHorizontalCTA = ({
  className = '',
  bodyText = 'Download the Fishbrain app and access the best fishing spots in your area',
}: IDownloadHorizontalCTAProps) => {
  return (
    <div
      style={{
        backgroundImage: `url(${AppsBannerBackground.src})`,
      }}
      className={twMerge(
        `hidden items-center justify-between rounded-lg bg-cover p-6 md:flex`,
        className,
      )}
    >
      <div className="flex items-center gap-4">
        <NextImage
          data-testid="appBannerLogo"
          alt="Fishbrain"
          src={logo}
          unoptimized
          className="max-h-24 justify-start"
        />
        <Heading className="text-left" variant="sm">
          {bodyText}
        </Heading>
      </div>
      <div className="ml-4 flex items-center justify-center sm:justify-start">
        <AppStoreButtons orientation="vertical" source="downloadAppHorizontalCTA" />
        <QRCode className="bg-sea-foam rounded-md p-2 md:ml-4" source="downloadAppHorizontalCTA" />
      </div>
    </div>
  );
};
